export default "__VITE_ASSET__e2ee23f5__"